module.exports = __webpack_public_path__ + "img/home-img.8f91ff89.png";